<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            md="6"
                            offset-md="3"
                    >

                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Activate tags') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">

                                <p class="body-1">{{ $t('Enter the code for your activ8 product to activate it, then assign the tags to yourself or a dependant') }}.</p>
                                <ValidationObserver ref="scanObserver">
                                    <v-form v-model="valid" @submit.prevent="handleSubmit">
                                        <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="code"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Code')"
                                                    required
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-form>

                                    <div class="d-flex justify-end">
                                        <v-btn tile elevation="0" color="primary" class="small" @click="handleSubmit">{{ $t('buttons.Activate') }}</v-btn>
                                    </div>

                                </ValidationObserver>

                                <v-dialog v-model="dialog" max-width="600px">
                                    <v-card
                                            class="mx-auto"
                                    >
                                        <v-card-title>{{ $t('headings.Assign tag') }}</v-card-title>
                                        <v-card-text>
                                            <ValidationObserver ref="activateObserver">
                                                <v-form @submit.prevent="handleActivate">
                                                    <ValidationProvider vid="myself" name="Myself" rules="required">
                                                        <v-checkbox v-model="myself" :label="$t('labels.Assign to myself')" required></v-checkbox>
                                                    </ValidationProvider>
                                                    <ValidationProvider vid="is_public" name="Public" rules="required">
                                                      <div class="d-flex">
                                                        <v-checkbox v-model="is_public" :label="$t('labels.Make this tag public')" required></v-checkbox>
                                                        <v-tooltip max-width="400" bottom>
                                                          <template v-slot:activator="{ on, attrs }">
                                                              <v-icon
                                                                  color="primary"
                                                                  dark
                                                                  v-bind="attrs"
                                                                  v-on="on"
                                                                  class="ml-3"
                                                              >
                                                                mdi-information
                                                              </v-icon>
                                                          </template>
                                                          <span>{{ $t('Make this tag public to allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                                        </v-tooltip>
                                                      </div>
                                                    </ValidationProvider>
                                                    <ValidationProvider vid="dependant" name="Dependant" :rules="`${myself ? '' : 'required'}`" v-slot="{ errors }">
                                                        <v-autocomplete
                                                                :items="dependants"
                                                                item-text="name"
                                                                item-value="id"
                                                                v-model="dependant"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Dependant')"
                                                                clearable
                                                                persistent-hint
                                                                :hint="$t('hints.Select a dependant to assign the tag to')"
                                                                @change="setIfPublic($event)"
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                    <v-row>
                                                        <v-col>
                                                            <v-btn class="mx-3" color="primary" @click="handleActivate">Assign</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </ValidationObserver>
                                        </v-card-text>
                                        <v-card-actions>
                                            <div class="flex-grow-1"></div>
                                            <v-btn class="small" color="blue darken-1" text @click="dialog = false">{{ $t('buttons.Close') }}</v-btn>
                                        </v-card-actions>
                                    </v-card>

                                </v-dialog>

                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>

</template>

<script>

    import { tagService, userService } from '../services';
    import { mapState, mapActions } from 'vuex'
    import { store } from '../store';
    import { extend } from 'vee-validate';
    import { is } from 'vee-validate/dist/rules';

    import Footer from './Footer'
    import {i18n} from "../i18n";

    // Add the required rule
    extend('is', is);

    export default {
        name: "Activate",
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + 'Activ8',
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              {
                name: 'description',
                content: i18n.t('Enter the code for your activ8 product to activate it, then assign the tags to yourself or a dependant')
              }
            ]
          }
        },
        components: {
            'Footer': Footer
        },
        data: () => ({
            dialog: false,
            code: '',
            valid: false,
            tag: {},
            dependant: '',
            myself: false,
            is_public: true
        }),
        mounted () {

            this.$gtag.pageview({
                page_path: '/activate'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        watch: {
            myself (val) {
                if (val) {
                    this.dependant = null;

                    if (this.user.make_tags_public) {
                      this.is_public = true
                    }
                }
                else if (!this.dependant) {
                  this.is_public = false
                }
            },
            dependant (val) {
                if (val) {
                    this.myself = false;
                }
            },
        },
        computed: {
            ...mapState({
                dependants: state => state.account.user.dependants,
                user: state => state.account.user,
                locale: state => state.locale,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            tagDetails () {
                return this.tag
            }
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            setIfPublic(event) {

              if (event) {
                let dependant = this.dependants.find(item=>item.id==event);
                if (dependant.make_tags_public) {
                  this.is_public = true
                }
                else {
                  this.is_public = false
                }
              }


            },
            onChange(event, index) {
                if (event, index) {
                    let dependant = this.dependants.find(item=>item.id==event);
                    this.dependant = dependant
                }
            },
            handleSubmit () {

                this.tag = [];
                this.found = false;
                store.dispatch('alert/clear');

                const { code } = this;

                let codeString = code;

                let observer = this.$refs.scanObserver;

                observer.validate().then(success => {
                    if (!success) {
                        return;
                    }

                    let n = code.lastIndexOf('/');
                    if (n >= 0) {
                        codeString = code.substring(n + 1);
                    }

                    tagService.findUnactivated(codeString).then(response => {

                        console.log(response)
                        if (response) {


                            this.$nextTick(() => {

                                this.tag = response.data;
                                this.code = '';

                                // remove errors
                                observer.reset();

                                this.dialog = true;
                            });
                        }


                    }).catch(function (error) {
                        if (error.response && [401, 403, 419].includes(error.response.status)) {
                            userService.logout().then(() => {
                                store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                            })
                        }
                        else if (error.response && error.response.status === 401) {
                          store.dispatch('alert/error', error.response.data.error, { root: true });
                        }
                        else {
                            if (error.response && error.response.data && error.response.data.error) {
                                store.dispatch('alert/error', error.response.data.error, {root: true});
                            }
                            else {
                                store.dispatch('alert/error', i18n.t('Unknown error occurred'), {root: true});
                            }
                        }

                    });
                })


                // if (tag) {
                //     router.push('scanned/' + tag)
                // }
            },
            handleActivate () {

                store.dispatch('alert/clear');

                let observer = this.$refs.activateObserver;

                let that = this

                observer.validate().then(success => {
                    if (!success) {
                        return;
                    }

                    tagService.activate(this.tag.qr_code, this.myself, this.dependant, this.is_public).then(response => {

                        if (response) {
                            this.tag = {};
                            this.dialog = false;
                            store.dispatch('alert/success', i18n.t('Tag activated'), {root: true});
                        }
                    }).catch(function (error) {
                            console.log(error)
                            that.tag = {};
                            that.dialog = false;

                    });
                })
            }
        }
    }
</script>

<style scoped>

</style>
